import * as React from 'react';

const OpenedSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="1" fillRule="evenodd" clipRule="evenodd" d="M2.45906 5.73877L8.9998 12.2795L15.5405 5.73877L16.2476 6.44588L9.35335 13.3402L8.9998 13.6937L8.64625 13.3402L1.75195 6.44588L2.45906 5.73877Z" fill="black"/>
  </svg>
);

export default OpenedSvg;
